module.exports = __webpack_public_path__ + "img/rewards.eebad2e0.png";